<script setup lang="ts">
import { InfoIcon, OctagonAlertIcon, CircleCheckIcon } from "lucide-vue-next";

const props = defineProps<{
  variant?: "default" | "error" | "success" | null;
}>();

const icon = () => {
  if (props.variant === "error") {
    return {
      value: OctagonAlertIcon,
      color: "text-red",
    };
  } else if (props.variant === "success") {
    return {
      value: CircleCheckIcon,
      color: "text-green",
    };
  } else {
    return {
      value: InfoIcon,
      color: "text-primary",
    };
  }
};
</script>

<template>
  <component :is="icon().value" :class="`size-4 shrink-0 ${icon().color}`" />
</template>
